import styled from '@emotion/styled';

import { linkWithUnderlineHover } from 'styles/mixins';

const Wrapper = styled.div`
  display: block;

  a {
    display: inline-block;
    color: ${(props) => props.theme.mainColors.primary};
    ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.primary)};
  }
  table {
    td {
      padding: 1rem;
    }
    td:first-of-type {
      text-align: right;
    }
  }
`;

export {
  Wrapper
};
